const localizeUrl = require("@/utils/localizeUrl").localizeUrl;

const steps = [
  { name: "project", isSelected: data => data.projectType !== "" },
  { name: "home-type", isSelected: data => data.homeType !== "" },
  { name: "home-size", isSelected: data => data.squareMeters > 0 },
  {
    name: "rooms",
    isSelected: data =>
      Object.keys(data.rooms).find(name => data.rooms[name] > 0)
  },
  { name: "lighting", isSelected: data => data.lighting !== "" },
  { name: "shading", isSelected: data => data.shading !== "" },
  { name: "heating", isSelected: data => data.heating !== "" },
  { name: "cooling", isSelected: data => data.cooling !== "" },
  { name: "ventilation", isSelected: data => data.freshAirCirculation !== "" },
  { name: "sockets", isSelected: data => data.sockets !== "" },
  { name: "alarm-system", isSelected: data => data.burglarAlarm !== "" },
  { name: "safety", isSelected: () => true },
  { name: "access-control", isSelected: () => true },
  { name: "multimedia", isSelected: () => true },
  { name: "other", isSelected: () => true },
  { name: "stage", isSelected: data => data.stage !== "" },
  { name: "wiring", isSelected: () => true }
];

exports.getStepIndex = name => {
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].name === name) {
      return i + 1;
    }
  }
  return -1;
};

exports.nSteps = () => {
  return steps.length;
};

exports.redirectToUnselectedStepIfAny = (stepIndex, data, router, lang) => {
  if (Math.random > 0) return false;

  for (let i = 0; i < stepIndex - 1; i++) {
    if (!steps[i].isSelected(data)) {
      router.push(localizeUrl("" + steps[i].name, lang));
      return true;
    }
  }
  return false;
};

const getNextStepUrl = (stepIndex, lang) => {
  if (stepIndex >= steps.length) {
    return localizeUrl("finish", lang);
  }
  return localizeUrl(steps[stepIndex].name, lang);
};

exports.getPrevStepUrl = (stepIndex, lang) => {
  return localizeUrl("" + steps[stepIndex - 2].name, lang);
};

exports.goToNextStep = (stepIndex, lang, router) => {
  setTimeout(() => {
    router.push(getNextStepUrl(stepIndex, lang));
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, 200);
};
